/* eslint-disable no-unused-vars */
/* eslint-disable react/no-children-prop */
import React from "react";
import { Wrapper, Label, Input } from "./style";

const RadioButton = ({ onClick, label, checked, value, name }) => {
  return (
    <Wrapper>
      <Label htmlFor="radio-button" children={label} />
      <Input type="radio" onClick={onClick} checked={checked} value={value} name={name} />
    </Wrapper>
  );
};

export default RadioButton;
